module.exports = __webpack_public_path__ + "img/foto2.653ee7e0.png";